import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.1831 4.85787L6.35811 9.08105L10.1831 13.3042L8.99977 14.6016L3.99977 9.08105L8.99977 3.56055L10.1831 4.85787Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ChevronLeftIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "chevron-left",
    width: "16",
    height: "18",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})